import { createAction } from 'redux-actions';
import { NEWS_REQUEST, NEWS_SUCCESS, NEWS_FAILURE } from './constants';

export const fetchNews = createAction(NEWS_REQUEST);
export const fetchNewsSuccess = createAction(NEWS_SUCCESS);
export const fetchNewsFailure = createAction(NEWS_FAILURE);
